import {
	Button,
	Flex,
	Icon,
	Menu,
	MenuItem,
	MenuTrigger,
	Popover,
	Text,
} from "@repo/ui";
import { useQuery } from "../db/DatabaseProvider";

type DepartmentPickerProps = {
	department: string | undefined;
	onChange?: (department: string) => void;
};

export function DepartmentPicker({
	department,
	onChange,
}: DepartmentPickerProps) {
	const departments = useQuery("department", (q) => q, []);

	return (
		<MenuTrigger>
			<Button variant="ghost" size="sm">
				<Flex
					gap="xs"
					align="center"
					borderRadius="md"
					style={{ minHeight: 20, width: "100%" }}
				>
					<Text size="sm" weight="medium" style={{ userSelect: "none" }}>
						{department || "No department"}
					</Text>
				</Flex>
			</Button>
			<Popover placement="bottom start">
				<Menu>
					{departments.map((dept) => (
						<MenuItem key={dept.id} onAction={() => onChange?.(dept.name)}>
							<Flex gap="xs" flex align="center">
								<Text size="sm" weight="medium" style={{ userSelect: "none" }}>
									{dept.name}
								</Text>
							</Flex>
							{department === dept.name && (
								<Icon name="Check" color="accent9" size="sm" />
							)}
						</MenuItem>
					))}
				</Menu>
			</Popover>
		</MenuTrigger>
	);
}
